import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import FieldString from '../../components/plain/FieldString';
import FieldReference from '../../components/plain/FieldReference';
import FieldObject from '../../components/plain/FieldObject';
import DivOrganization, {validateOrganization} from './components/DivOrganization';

import {getLanguage} from '../../util/localStorage';
import {CLASS_LIBRARY, CLASS_ORGANIZATION } from '../../util/consts/classes';
import {FORM_LIBRARY_PLAIN, FORM_ORGANIZATION_TABLE} from '../../util/consts/forms';
import {ORGANIZATION_PLAIN_PATH} from '../../util/routes';

class LibraryPlainPage extends PlainPage {
	
	constructor(props) {
		super(props);
		this.formPath = FORM_LIBRARY_PLAIN;
		this.formTitle = 'Бібліотека';
		this.buildInstanceCard = this.buildLibraryCard;
	}
	componentDidMount = async () => {
		this.init( CLASS_LIBRARY );
		document.title = 'BOM. ' + this.formTitle;
	}
	
	buildLibraryCard = (libraryInstance) => {
		let card = '';
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of libraryInstance.rootField.value.organization.value.names.value) {
			if( n.value.language.value == currentLanguage && n.value.name.value ) {
				name = n;
				break;
			}
		}
		if( name == null && libraryInstance.rootField.value.organization.value.names.value.length > 0)
			name = libraryInstance.rootField.value.organization.value.names.value[0];
		if( name != null ) {
			if( name.value.name.value )
				card += name.value.name.value;
			else if( name.value.shortName.value )
				card += name.value.shortName.value;
		} 
		return card;
	}
	
	validateInstance() {
		return validateOrganization(this.instance, this.instance.rootField.value.organization);
	}
	
	renderBody() {
		let instance = this.state.instance;
		let fieldGroup = instance.rootField;
		let readOnly = this.instanceReadOnly;
		let fieldOrganization = instance.rootField.value.organization;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldReference instance={instance} path={'mainOrgRef'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							refNodes = {[
								{
									classId: CLASS_ORGANIZATION, plainFormPath: ORGANIZATION_PLAIN_PATH, 
									selectInstanceFormId: FORM_ORGANIZATION_TABLE,
									selectInstanceFormTitle: 'Організації'
								}
								
							]}
							styles={{ divMain: {flexGrow: '1'} }}
						/>
					</div>
				
					<div style={{padding: '20px', border: '1px solid blue'}}>
						<div style={{marginBottom: '15px'}}>
							<FieldObject instance={instance} path={'organization'} plain={this} parentField={fieldGroup} 
								readOnly={readOnly}
								refNodes = {[
									{
										classId: CLASS_ORGANIZATION, plainFormPath: ORGANIZATION_PLAIN_PATH, 
										selectInstanceFormId: FORM_ORGANIZATION_TABLE,
										selectInstanceFormTitle: 'Організації'
									},
								]}
								styles={{label: {divMain: {marginRight: '10px', fontWeight: 'bold'}}}}
							/>
						</div>
						<DivOrganization instance={instance} fieldGroup={fieldOrganization} readOnly={readOnly} plain={this}/>
					</div>
				</div>
			</div>
		)
	}
}

export default LibraryPlainPage;
